// extracted by mini-css-extract-plugin
export default {"mainContainer":"downloadReport_mainContainer__ULrK4","detailsContainer":"downloadReport_detailsContainer__iBqvN","details":"downloadReport_details__5iV0D"};